import React from 'react';

const HeroSection = ({ onFormChange, activeForm }) => {
    
    // Smooth scroll utility to focus on the form once selected
    const scrollToForm = () => {
        const element = document.getElementById('registration-section');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className="hero" id="home">
            <div className="container">
                <h2 className="h1 hero-title">Welcome to School Meal Registration</h2>
                <p className="hero-text">
                    Specialized catering and logistics services for onshore and offshore operations, camp management,
                    ship and store supplies as well as laundry, housekeeping, and janitorial services.
                </p>
                <div className="btn-group">
                    <button className="btn btn-primary">Discover more</button> 
                    
                    <button 
                        onClick={() => { onFormChange('regular'); scrollToForm(); }}
                        className={`btn ${activeForm === 'regular' ? 'btn-secondary active' : 'btn-secondary'}`}
                    >
                        Register now
                    </button>
                    
                    <button 
                        onClick={() => { onFormChange('summer'); scrollToForm(); }}
                        className={`btn ${activeForm === 'summer' ? 'btn-secondary active' : 'btn-secondary'}`}
                    >
                        Summer Camp Register
                    </button> 
                </div>
            </div>
        </section>
    );
};

export default HeroSection;